"use strict";
exports.__esModule = true;
var angular = require("angular");
require('./global-tables.component.css');
var saveBolb = (function () {
    var a = document.createElement('a');
    a.style.cssText = 'display: none !important';
    document.body.appendChild(a);
    return function (blob, fileName) {
        var url = window.URL.createObjectURL(blob.data);
        a.href = url;
        a.download = fileName;
        a.click();
        window.URL.revokeObjectURL(url);
    };
})();
var COMPONENT_NAME = 'smartorg.r6.mgmt.globalTables';
exports.BroadcastKeys = {
    INIT: 'globalTables:INIT'
};
var GlobalTablesComponent = /** @class */ (function () {
    function GlobalTablesComponent($scope, $timeout, $http) {
        var _this = this;
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.$http = $http;
        $scope.$on(exports.BroadcastKeys.INIT, function () {
            _this.displayTableList();
        });
    }
    GlobalTablesComponent.prototype.back = function () {
        this.$scope.$emit('workbench:back');
    };
    GlobalTablesComponent.prototype.clearFileSelect = function () {
        this.selectedFile = null;
        document.querySelector("input[type='file']").value = null;
    };
    GlobalTablesComponent.prototype.selectTable = function (tableName) {
        this.selectedTable = tableName;
        this.newTableName = tableName;
        this.clearFileSelect();
        this.previewTable();
    };
    GlobalTablesComponent.prototype.previewTable = function () {
        var _this = this;
        var ctrl = this;
        ctrl.selectedTablePreview = null;
        ctrl.selectedTableFileName = null;
        ctrl.smartorgApi
            .previewGlobalTable(ctrl.selectedTable)
            .then(function (response) {
            console.log('PREVIEW', response);
            var colDefs = undefined;
            if (response.columns) {
                colDefs = response.columns.map(function (key) { return ({
                    displayName: key,
                    field: btoa(key),
                    minWidth: 100
                }); });
            }
            ctrl.savedOn = 'savedOn' in response ? response.savedOn : '';
            ctrl.savedBy = 'savedBy' in response ? response.savedBy : '';
            ctrl.tableRawData = response.data;
            ctrl.selectedTablePreview = {
                columnDefs: colDefs,
                data: response.data.map(function (row) {
                    var newRow = {};
                    Object.entries(row).forEach(function (_a) {
                        var k = _a[0], v = _a[1];
                        newRow[btoa(k)] = v;
                    });
                    return newRow;
                })
            };
            ctrl.selectedTableFileName = response.filename;
            _this.$timeout();
        })["catch"](function (err) {
            ctrl.showAlert({
                type: 'danger',
                title: 'Failed to load preview!',
                message: err.message
            });
        });
    };
    GlobalTablesComponent.prototype.downloadExcel = function () {
        var _this = this;
        var ctrl = this;
        ctrl.smartorgApi
            .downloadGlobalTables(ctrl.selectedTable)
            .then(function (response) {
            saveBolb(response, _this.selectedTableFileName);
        })["catch"](function (err) {
            ctrl.showAlert({
                type: 'danger',
                title: 'Failed to download excel file!',
                message: err.message
            });
        });
    };
    GlobalTablesComponent.prototype.clearUp = function () {
        this.selectedTable = null;
        this.newTableName = null;
        this.selectedTablePreview = null;
        this.selectedTableFileName = null;
        this.uploading = false;
        this.clearFileSelect();
    };
    GlobalTablesComponent.prototype.reset = function () {
        this.uploading = false;
        this.clearFileSelect();
        this.$scope.$apply();
    };
    GlobalTablesComponent.prototype.displayTableList = function () {
        var ctrl = this;
        this.clearUp();
        this.smartorgApi
            .getListOfGlobalTables()
            .then(function (tableList) {
            ctrl.tableList = tableList;
            ctrl.$timeout();
        })["catch"](function (err) {
            console.error(err);
        });
    };
    GlobalTablesComponent.prototype.processUpload = function () {
        var ctrl = this;
        ctrl.uploading = true;
        this.handleFileChange(this.selectedFile);
    };
    GlobalTablesComponent.prototype.uploadExcel = function () {
        var ctrl = this;
        this.smartorgApi
            .uploadGlobalTableExcel(this.newTableName, this.selectedFile)
            .then(function (response) {
            if (response.status === 201) {
                var tableName = ctrl.newTableName;
                ctrl.newTableName = null;
                ctrl.selectedFile = null;
                ctrl.displayTableList();
                ctrl.selectTable(tableName);
                ctrl.showAlert({
                    type: 'success',
                    title: 'Upload Successful!',
                    message: "Excel file has been uploaded successfully and saved as \"" + tableName + "\"."
                });
            }
            else {
                throw response;
            }
            ctrl.uploading = false;
        })["catch"](function (err) {
            ctrl.uploading = false;
            var errMsg = err.message.startsWith && err.message.startsWith('Unsupported format')
                ? "Unsupported Format. File formats supported are: xls, xlsx and xlsm only."
                : err.message;
            ctrl.showAlert({
                type: 'danger',
                title: 'Upload Failed!',
                message: errMsg
            });
        });
    };
    GlobalTablesComponent.prototype.handleFileChange = function (file) {
        var _this = this;
        this.loadXlsxScript(function () {
            var reader = new FileReader();
            reader.onload = function (e) {
                var data = new Uint8Array(e.target.result);
                var workbook = XLSX.read(data, { type: 'array' });
                var firstSheetName = workbook.SheetNames[0];
                var worksheet = workbook.Sheets[firstSheetName];
                var newExcelData = XLSX.utils.sheet_to_json(worksheet, { defval: '' });
                var missingRows = _this.getMissingRows(newExcelData, _this.tableRawData);
                if (missingRows.length > 0) {
                    _this.showUploadWarning(missingRows);
                }
                else {
                    _this.uploadExcel();
                }
            };
            reader.readAsArrayBuffer(file);
        });
    };
    GlobalTablesComponent.prototype.showUploadWarning = function (missingRows) {
        var _this = this;
        var dialog = bootbox.dialog({
            title: "Confirm Upload",
            message: this.generateWarningHtml(missingRows),
            buttons: {
                confirm: {
                    label: "Yes, Upload",
                    className: "btn-primary",
                    callback: this.uploadExcel.bind(this)
                },
                cancel: {
                    label: "No, Cancel",
                    className: "btn-secondary",
                    callback: function () {
                        _this.reset();
                    }
                }
            }
        });
        // Check for scrollable content after dialog is fully rendered with a slight delay
        dialog.on('shown.bs.modal', function () {
            // Add a small timeout to ensure content is fully rendered
            setTimeout(function () {
                var modalContent = dialog.find('.bootbox-body');
                var container = modalContent.find('.scroll-container ul')[0];
                console.log('Container scrollHeight:', container.scrollHeight, 'clientHeight:', container.clientHeight);
                if (container && container.scrollHeight > container.clientHeight) {
                    var fadeGradient_1 = modalContent.find('.fade-gradient')[0];
                    var scrollIndicator_1 = modalContent.find('.scroll-indicator')[0];
                    if (fadeGradient_1) {
                        fadeGradient_1.style.display = 'block';
                        console.log('Showing fade gradient');
                    }
                    if (scrollIndicator_1) {
                        scrollIndicator_1.style.display = 'block';
                        console.log('Showing scroll indicator');
                    }
                    // Add scroll event listener to hide gradient when scrolled to bottom
                    $(container).on('scroll', function () {
                        var scrolledToBottom = this.scrollTop + this.clientHeight >= this.scrollHeight - 10; // Within 10px of bottom
                        if (scrolledToBottom) {
                            fadeGradient_1.style.opacity = '0';
                            scrollIndicator_1.style.opacity = '0';
                        }
                        else {
                            fadeGradient_1.style.opacity = '1';
                            scrollIndicator_1.style.opacity = '1';
                        }
                    });
                }
                else {
                    console.log('Content not scrollable or container not found');
                }
            }, 100); // Small delay to ensure content is rendered
        });
    };
    GlobalTablesComponent.prototype.generateWarningHtml = function (missingRows) {
        var _this = this;
        return "\n          <p>\n            Newly uploaded database table <strong>" + this.selectedTable + "</strong> will overwrite the already existing " + this.selectedTable + " table.\n          </p>\n          <p>\n            <strong>Warning:</strong> The new table is missing some rows from the existing table.\n          </p>\n          <p>Here is the list of rows that are modified/removed in the new table:</p>\n          <div style=\"position: relative;\" class=\"scroll-container\">\n            <ul style=\"max-height: 200px; overflow-y: auto; padding-left: 20px; margin-right: 10px; scrollbar-width: thin; scrollbar-color: #888 #f1f1f1;\">\n              " + missingRows.map(function (row) { return "<li>" + _this.summarizeRow(row) + "</li>"; }).join('') + "\n            </ul>\n            <div class=\"fade-gradient\" style=\"position: absolute; left: 0; right: 10px; bottom: 0; height: 40px; pointer-events: none; background: linear-gradient(to bottom, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 100%); display: none; z-index: 10; transition: opacity 0.2s ease;\"></div>\n          </div>\n          <p>\n            Removing rows can result in <strong>orphan tags</strong> if they are assigned to nodes in portfolio.<br>\n            The orphan nodes can be cleared using a standalone script. Contact Administrator to run the script.\n          </p>\n          <p>Are you sure you want to upload the new database table?</p>\n        ";
    };
    GlobalTablesComponent.prototype.summarizeRow = function (row) {
        var keys = Object.keys(row);
        if (keys.length === 0)
            return "<code>[Empty row]</code>";
        var isNumeric = function (key) { return /^\d+$/.test(key); };
        // Sort keys: non-numeric first, then numeric
        var sortedKeys = keys.sort(function (a, b) {
            var aIsNum = isNumeric(a);
            var bIsNum = isNumeric(b);
            if (aIsNum && !bIsNum)
                return 1;
            if (!aIsNum && bIsNum)
                return -1;
            return a.localeCompare(b);
        });
        // Show first 3 fields for brevity
        var summary = sortedKeys.slice(0, 3).map(function (key) {
            var val = row[key];
            return "<strong>" + key + "</strong>: " + val;
        }).join(', ');
        return summary + (sortedKeys.length > 3 ? '...' : '');
    };
    GlobalTablesComponent.prototype.getMissingRows = function (newData, existingData) {
        var newRowSet = new Set(newData.map(function (row) { return JSON.stringify(row); }));
        return existingData.filter(function (row) {
            var res = !newRowSet.has(JSON.stringify(row));
            return res;
        });
    };
    GlobalTablesComponent.prototype.loadXlsxScript = function (callback) {
        if (window['XLSX']) {
            callback(); // Already loaded
            return;
        }
        var script = document.createElement('script');
        script.src = 'https://cdn.sheetjs.com/xlsx-0.20.0/package/dist/xlsx.full.min.js';
        script.onload = function () { return callback(); };
        script.onerror = function () { return console.error('Failed to load xlsx script.'); };
        document.head.appendChild(script);
    };
    GlobalTablesComponent.prototype.confirmDelete = function (tableName) {
        var ctrl = this;
        bootbox.dialog({
            message: "Delete table <b>" + tableName + "</b>?",
            title: 'Confirm Deletion',
            buttons: {
                confirm: {
                    label: 'Delete',
                    className: 'btn-danger',
                    callback: function () {
                        ctrl.deleteGlobalTable(tableName);
                    }
                },
                cancel: {
                    label: 'Cancel',
                    className: 'btn-primary'
                }
            }
        });
    };
    GlobalTablesComponent.prototype.deleteGlobalTable = function (tableName) {
        var ctrl = this;
        this.smartorgApi
            .deleteGlobalTable(tableName)
            .then(function (response) {
            if (response.status === 201) {
                ctrl.displayTableList();
                ctrl.showAlert({
                    type: 'success',
                    title: 'Delete Successful!',
                    message: "Table \"" + tableName + "\" has been deleted successfully."
                });
            }
            else {
                throw response;
            }
        })["catch"](function (err) {
            ctrl.showAlert({
                type: 'danger',
                title: 'Delete Failed!',
                message: err.message
            });
        });
    };
    return GlobalTablesComponent;
}());
angular
    .module(COMPONENT_NAME, ['ui.grid', 'ui.grid.resizeColumns', 'ui.grid.autoResize', 'ui.grid.moveColumns'])
    .component('globalTablesManage', {
    template: require('./global-tables.component.html'),
    bindings: {
        smartorgApi: '=',
        showAlert: '&?'
    },
    controller: GlobalTablesComponent
})
    .directive('fileModel', [
    '$parse',
    function ($parse) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                var model = $parse(attrs.fileModel);
                var modelSetter = model.assign;
                element.bind('change', function () {
                    scope.$apply(function () {
                        modelSetter(scope, element[0].files[0]);
                    });
                });
            }
        };
    },
]);
exports["default"] = COMPONENT_NAME;
//# sourceMappingURL=global-tables.component.js.map


// WEBPACK FOOTER //
// ./app/widgets/management/global-tables/global-tables.component.js